export const NumberDisplay = ({ number }: { number: string }) => {
    const digits = number.split('');
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                direction: 'ltr',
            }}
        >
            {digits.map((digit, index) => (
                <div

                    key={index}
                    style={{
                        width: '2em',
                        height: '2em',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid #ccc',
                        borderLeft: index !== 0 ? 'none ' : '1px solid #ccc',
                        fontWeight: 'bold',
                        fontSize: '20px',
                        background: 'var(--header-color)',
                        paddingTop: '2.2px',
                        borderRadius:
                            index === digits.length - 1
                                ? '0 5px 5px 0'
                                : index === 0
                                    ? '5px 0 0 5px'
                                    : '0%',
                    }}
                >
                    {digit}
                </div>
            ))}
        </div>
    );
};
